import React from 'react';
import { TravelJournalArticlesType } from 'types/types';
import styles from './FeaturedArticle.module.scss';
import { Body, Heading } from 'components/text';
import Image from 'next/image';
import Arrow from 'assets/svg/arrow-long-right.svg';
import ArticleLink from 'blocks/travel-journal-articles/home/article-link';
import CategoryLink from 'blocks/travel-journal-articles/home/category-link/CategoryLink';
import Container from 'components/container';

export interface FeaturedArticleProps {
  article: TravelJournalArticlesType;
}

const FeaturedArticle: React.FC<FeaturedArticleProps> = ({ article }) => {
  if (!article) {
    return null;
  }
  const { header_image, categories } = article;

  return (
    <Container as="article" className={styles.container}>
      <div className={styles.containerInner}>
        <div className={styles.cardHeader}>
          <div className={styles.cardHeaderTop}>
            <div className={styles.categories}>
              {categories?.map((category, index) => (
                <CategoryLink key={index} category={category}>
                  <Body color="gold-dark" weight="demiBold">
                    {category.name}
                  </Body>
                </CategoryLink>
              ))}
            </div>
            <ArticleLink key={article.id} article={article}>
              <Heading as="h4" color="grey-dark" weight="medium">
                {article.title}
              </Heading>
            </ArticleLink>
          </div>
          <div className={styles.introduction}>
            <Body color="grey-dark" fontSize={18}>
              {article.introduction}
            </Body>
            <ArticleLink key={article.id} article={article}>
              <div className={styles.arrow}>
                <Arrow />
                <Body color="gold-dark" weight="demiBold">
                  Read more
                </Body>
              </div>
            </ArticleLink>
          </div>
        </div>
        <div className={styles.imageContainer}>
          <ArticleLink key={article.id} article={article}>
            <Image
              src={header_image}
              layout="fill"
              objectPosition="center"
              objectFit="cover"
              alt={article.title}
              sizes="(max-width: 1024px) 200vw, 1920px"
            />
          </ArticleLink>
        </div>
      </div>
    </Container>
  );
};

export default FeaturedArticle;
